// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import nds from '@nerdwallet/base-styles/classes';

import { Title, Box, Text } from '@nerdwallet/currency';

import { stringTextAreaSpec } from '../../lib/editing-configs';
import parseMarkdownLinks from '../../lib/parse-md-links';

const textAlignCenter = nds('text-align-center');

const TwoColText = ({ content, header, size }) => {
  const centerWhenSmall = size === 'sm' ? textAlignCenter : '';
  return (
    <Box className="row-two-col__text">
      <Title
        className={classNames([
          'row-two-col__text__header',
          centerWhenSmall,
          {
            spaced: header !== '',
          },
        ])}
        size="small"
      >
        {header}
      </Title>
      <Box className="row-two-col__text__content">
        <Text align={size === 'sm' ? 'center' : 'left'}>
          {parseMarkdownLinks(content, false)}
        </Text>
      </Box>
    </Box>
  );
};

TwoColText.propTypes = {
  header: PropTypes.string,
  className: PropTypes.string,
  content: PropTypes.string,
  size: PropTypes.oneOf(['', 'sm', 'md', 'lg']),
};

TwoColText.defaultProps = {
  header: '',
  content: '',
};

TwoColText.getEditingConfig = () => [
  stringTextAreaSpec('header', 'Heading Text'),
  stringTextAreaSpec('content', 'Paragraph Text', {
    help: `Want a hyperlink? Write it like this: [Hi!](www.thing.com).
       NW links should be relative, e.g., [Home](/home)`,
  }),
];

TwoColText.displayName = 'TwoColText';

export default TwoColText;
